import React from 'react';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import useDebugInformation from '../../hooks/useDebugInformation';
import { ui } from '../../interfaces/interfaces';
import { ContactPrefix } from '../../utilities/BasicTypes';
import test from '../../utilities/testing';
import { useAppSelector } from "@store/hooks";

const name = "ContactButtonPF"

const handleFormPreFill = (prefix: Props["prefix"], parent: string,): void => {
    const formData = test.contactForm();
    const isMobile = formData.phoneNumber.startsWith("07")
    if (prefix === "PropertyContact" || prefix === "LandlordContact" || prefix === "CarePlanBillingContact" || prefix === "CarePlanCustomerContact" || prefix === "BookingPaymentContact") {
        ui[`${prefix}FirstName`] = formData.firstName;
        ui[`${prefix}LastName`] = formData.lastName;
        ui[`${prefix}Email`] = formData.email;
        ui[`${prefix}Mobile`] = isMobile ? formData.phoneNumber : "";
        ui[`${prefix}Landline`] = isMobile ? "" : formData.phoneNumber;
        ui[`${prefix}Title`] = formData.title;
    }
    if (prefix === "RelatedContact") {
        ui.RelatedContactTitle = formData.title
        ui.RelatedContactFirstName = formData.firstName
        ui.RelatedContactLastName = formData.lastName
        ui.RelatedContactRelationship = "Family - Father"
        ui.RelatedContactMobile = isMobile ? formData.phoneNumber : ""
        ui.RelatedContactLandline = !isMobile ? formData.phoneNumber : ""
    }
}

type Props = {
    tooltip: string;
    prefix: ContactPrefix,
    parent: string;
    disabledBtn: boolean
}

const ContactButtonPF: React.FC<Props> = ({ tooltip, prefix, parent, disabledBtn }) => {
    const contactFormValid = useAppSelector(({ state }) => state[`${prefix}Valid`])
    const debugName = `${parent}▷[${name}]`

    const showModal = React.useCallback(() => handleFormPreFill(prefix, parent), [parent, prefix])

    useDebugInformation(debugName, { tooltip, prefix, parent, disabledBtn, contactFormValid })
    return (
        <Tooltip title={tooltip ? tooltip : "Contact"}>
            <span>
                <IconButton onClick={showModal} disabled={disabledBtn ? disabledBtn : false}>
                    <Badge color="primary" invisible={disabledBtn ? disabledBtn : false} >
                        <ContactPageIcon color={disabledBtn ? "disabled" : "action"} />
                    </Badge>
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default React.memo(ContactButtonPF)
